<template>
  <div
    @mouseenter="$emit('hover')"
    @click="check('click')"
    v-disable="disabled"
    class="option-wrapper">
    <div class="icon-wrapper" v-disable="disabled">
      <!-- TODO el negativo se ha borrado porque ahora solo hay votos positivos -->
      <i v-disable="disabled" class="thumbs-icon fa-thumbs-up" :class="active ? 'fas' : 'fal'"></i>
    </div>
    <div class="quantity">{{ total }}</div>
    <edi-dropdown-modal v-if="showUserList && users.length" @mouseleave.stop.native="$emit('mouseleave')">
      <edi-comment-user-list :users="users"></edi-comment-user-list>
    </edi-dropdown-modal>
  </div>
</template>

<script>
  import EdiCommentUserList from '../list/EdiCommentUserList'
  import { EdiDropdownModal } from '../../../components';

  export default {
    name: 'edi-comment-valuation-btn',
    components: {
      EdiCommentUserList,
      EdiDropdownModal
    },
    props: {
      positive: Boolean,
      total: Number,
      users: Array,
      showUserList: Boolean,
      active: Boolean,
      disabled: Boolean
    },
    methods: {
      check(event) {
        if (!this.disabled) {
          this.$emit(event);
        }
      }
    }
  }
</script>
